import React, { useEffect, useState, useMemo } from 'react';
import SelfCareExistingPackage from './SelfCareExistingPackage';
import { connect } from 'react-redux';
import {
  setActiveLobbyTab,
  resetSocPackageRemoveStatus
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { getCustomerAbroadPackages , getUsageData , getCustomerAbroadPackagesBusinessIndividual} from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import { isMobile, isBrowser } from 'react-device-detect';
import { lobbyTabsEnum } from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import PlaneLoader from '../AbroadTicketBlock/PlaneLoader';
import { gaAutoPackagesContainer, gaHiddenPackagesContainer } from '../CellcomAbroadLobbyBlock/gaReports';
import lodash from 'lodash';
import { formatDateToMonthFirst } from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { isNullOrEmpty, navigateToUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { setAbroadLobbyBlockId } from '../../Page/SelfCarePage/SelfCareSlice';
import SelfCareAbroadExistingPackagesSkeleton from './SelfCareAbroadExistingPackagesSkeleton';
import SelfCareAbroadScreenIlAddon from './SelfCareAbroadScreenIlAddon';
import SelfCareAbroadInsurance from './SelfCareAbroadInsurance';
import { AddonType } from '../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';


export function isThereValidPackages(packages) {
  if (Array.isArray(packages) && packages.length > 0) {
    const today = new Date();
    const hasValidPackage = packages?.some((packageItem) => {
      if (!packageItem?.socEffactiveDate || !packageItem?.socExpDate) {
        return false;
      }
      const effDate = new Date(formatDateToMonthFirst(packageItem?.socEffactiveDate));
      const expDate = new Date(formatDateToMonthFirst(packageItem?.socExpDate));
      return today >= effDate && today <= expDate;
    });
    return hasValidPackage;
  }
  return false;
}

function SelfCareAbroadCustomerExistingPackagesMain({
  packageData,
  autoPackageData,
  setActiveLobbyTab,
  customerAbroadPackages,
  userUsageData,
  epiStyleInitializationData,
  context,
  shadowPackagesNotToShowMessage,
  businessIndividual,
  getCustomerAbroadPackages,
  getCustomerAbroadPackagesBusinessIndividual,
  resetSocPackageRemoveStatus,
  privateId,
  businessId,
  goldBusinessSocPackageFolderId,
  mobile,
  portalsBlock,
  socPackageRemoveStatus,
  phoneNumber,
  iContent,
  hideAppLoader,
  loader,
  selfCareData,
  setAbroadLobbyBlockId,
  isCancelOrUpdatePackagePending,
  abroadAddons,
  insuranceInfo,
  subscriberMobile,
  customerAbroadPackagesStatus,
  isFetchAbroadData
}) {
  const userSocPackages = useMemo(() => renderPackageBoxes(), [packageData]);
  useEffect(() => {
    if (autoPackageData?.length > 0) {
      let packagesArrayStr = lodash.map(autoPackageData, 'socName'); //get names
      gaAutoPackagesContainer(packagesArrayStr);
    }
  }, [autoPackageData]);



  const userType = userUsageData ? userUsageData?.userType : '';
  const txt = `כדי להימנע מחיובים גבוהים, כדאי לרכוש חבילה או להימנע משימוש בנייד בחו"ל`;
  const idForPrivatePackages = iContent.linkForPrivatePackages?.value?.id;
  const idForBusinessPackages = iContent.linkForBusinessPackages?.value?.id;
  const idForBusinessGoldPackages = iContent.linkForBusinessGoldPackages?.value?.id;
  const idForAddonsPackages = iContent.linkForAddonsPackages?.value?.id;
  const linkForMoreBusinessPackages = iContent.linkForMoreBusinessPackages?.value;
  const linkForMorePrivatePackages = iContent.linkForMorePrivatePackages?.value?.url;
  const linkForCollaborationInsurance = iContent.linkForCollaborationInsurance?.value?.url;
  const abroadLobbyBlockId = iContent.abroadLobbyBlockId?.value;
  const linkForMorePackages = selfCareData?.selectedSubscriber?.isBusinness ? linkForMoreBusinessPackages : linkForMorePrivatePackages;

  const memoizedParams = useMemo(
    () => ({
      mobile: subscriberMobile ?? phoneNumber,
      privateBlockId: idForPrivatePackages,
      businessBlockId: idForBusinessPackages,
      goldBusinessPackagesBlockId: idForBusinessGoldPackages,
      addonsFolderBlockId: idForAddonsPackages,
      noLoader: true,
    }),
    [subscriberMobile],
  );


  useEffect(() => {
    if (!selfCareData?.abroad?.abroadLobbyBlockId) {
      setAbroadLobbyBlockId(abroadLobbyBlockId);
    }
  }, []);

  useEffect(() => {
    const getCurrentCustomerAbroadPackages = async () => {
      await getCustomerAbroadPackages(memoizedParams);
    };
    if (allParamsAreDefined() && !isFetchAbroadData ) {
      getCurrentCustomerAbroadPackages();
    }
  }, [memoizedParams, isFetchAbroadData, subscriberMobile]);

  useEffect(() => {
    hideAppLoader();
  }, []);

  function allParamsAreDefined() {
    return subscriberMobile && idForPrivatePackages && idForBusinessPackages && idForBusinessGoldPackages && idForAddonsPackages;
  }

  function renderPackageBoxes() {
    if (typeof packageData === 'string' || packageData instanceof String) {
      return;
    }
    if (packageData && packageData.length > 0) {
      return (
        <div className='row abroad-package-container'>
          <div className='header'>חבילות חו"ל שלי</div>
          {packageData.map(function (pData, i) {
            return (
              <SelfCareExistingPackage
                packageData={pData}
                key={i}
                epiStyleInitializationData={epiStyleInitializationData}
                context={context}
                customerAbroadPackages={customerAbroadPackages}
                iContent={iContent}
                abroadWorld={true}
              />
            );
          })}
          {isThereValidPackages(packageData) && <BtnSubmit text={'לרכישת חבילת המשך'} onclick={() => navigateToUrl(linkForMorePackages)} />}
        </div>
      );
    }
  }

  function goToBuyPackage() {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (userType === 'Private') {
      setActiveLobbyTab(lobbyTabsEnum.PRIVATE);
    } else {
      if (!businessIndividual) setActiveLobbyTab(lobbyTabsEnum.BUSINESSACCOUNT);
      else setActiveLobbyTab(lobbyTabsEnum.BUSINESSINDIVIDUAL);
    }
  }


  function renderHiddenPackagesMessage() {
    gaHiddenPackagesContainer();
    return (
      <>
        <div className='package-box'>
          <div className='top-box text-center'>
            <div className='hidden-packages-image'>
              <svg id='noun_Heart_4164839' xmlns='http://www.w3.org/2000/svg' width='60' height='56.01'>
                <defs></defs>
                <path
                  id='Path_284'
                  data-name='Path 284'
                  class='cls-1'
                  d='M45 6a17.083 17.083 0 0 0-13 6.039A17 17 0 0 0 2 23c0 16.329 28.2 37.887 29.4 38.8a1 1 0 0 0 1.208 0C33.8 60.887 62 39.329 62 23A17.019 17.019 0 0 0 45 6zM32 59.733C27.866 56.481 4 37.088 4 23a15.006 15.006 0 0 1 27.189-8.754 1.038 1.038 0 0 0 1.622 0A15.006 15.006 0 0 1 60 23c0 14.082-23.866 33.48-28 36.733z'
                  transform='translate(-2 -5.993)'
                />
                <path
                  id='Path_285'
                  data-name='Path 285'
                  class='cls-1'
                  d='M32 16a17 17 0 1 0 17 17 17 17 0 0 0-17-17zm14.844 14.956-2.292 1.15a1 1 0 0 0-.513.619l-1.929 6.751-.7.7.576-4.029a1 1 0 0 0-.543-1.037l-3.589-1.794L37.031 30l.806-3.225 2.479-.826A1 1 0 0 0 41 25v-2a1 1 0 0 0-.293-.707l-1.48-1.48.377-.72a15.009 15.009 0 0 1 7.24 10.863zM27.014 18.87 29 21.351v.8l-5.165.861A1 1 0 0 0 23 24v1.618l-1.7-.558a1 1 0 0 0-1.262.635l-.99 2.991a1 1 0 0 0 .149.914l3 4a1 1 0 0 0 .6.38l4.868.974 2.812 1.406-2.255 3.022a.97.97 0 0 0-.168.35l-1.03 4.02a1.007 1.007 0 0 0 0 .491l.789 3.152a14.929 14.929 0 0 1-1.432-.5l-.4-3.029a1 1 0 0 0-.285-.578l-3.49-3.49.678-1.356a1 1 0 0 0-.038-.962l-3-5a1 1 0 0 0-.613-.455l-2.167-.545a15.024 15.024 0 0 1 9.943-12.61zm-9.987 14.665 1.328.334 2.5 4.175-.755 1.509a1 1 0 0 0 .188 1.154l3.759 3.76.175 1.337a14.986 14.986 0 0 1-7.195-12.269zM32 48a15.049 15.049 0 0 1-2-.15L29.032 44l.917-3.584L32.8 36.6a1 1 0 0 0-.354-1.493l-4-2a1 1 0 0 0-.251-.085L23.57 32.1l-2.457-3.28.512-1.547 2.061.679A1 1 0 0 0 25 27v-2.153l5.165-.861A1 1 0 0 0 31 23v-2a1 1 0 0 0-.219-.625l-1.673-2.089a14.92 14.92 0 0 1 8.718.892l-.712 1.358a1 1 0 0 0 .179 1.171L39 23.414v.865l-2.316.772a1 1 0 0 0-.654.706l-1 4a1 1 0 0 0 0 .486l1 4a1 1 0 0 0 .523.652l3.355 1.677-.9 6.286a1 1 0 0 0 1.7.849l3-3a.994.994 0 0 0 .254-.432l1.88-6.578 1.153-.579A15.014 15.014 0 0 1 32 48z'
                  transform='translate(-2 -5.993)'
                />
              </svg>
            </div>
            <div className='hidden-packages-text'>שימו לב!</div>
            <div className='hidden-packages-text'>למנוי זה קיימות חבילות נוספות שרכש בעצמו ולא ניתן להציגן כאן</div>
          </div>
        </div>
      </>
    );
  }

  function abroadCustomerExistingPackagesState() {
    return userSocPackages;
  }


  function renderAbroadCustomerExistingPackages() {
    if (packageData.length > 0) {
      return (
        <div className='selfcare-abroad-customer-existing-packages-main'>
          {abroadCustomerExistingPackagesState()}
          {shadowPackagesNotToShowMessage && renderHiddenPackagesMessage()}
        </div>
      );
    }
    return null;
  }

  function renderAbroadCustomerDefaultExistingPackages() {
    if (Array.isArray(autoPackageData) && autoPackageData.length > 0) {
      return (
        <div className='selfcare-abroad-customer-existing-packages-main'>
          <div className='row abroad-package-container'>
            <div className='header'>
              חבילות <span className='bold'>אוטומטיות </span>
            </div>
            {autoPackageData.map(function (pData, i) {
              return (
                <SelfCareExistingPackage
                  packageData={pData}
                  key={i}
                  epiStyleInitializationData={epiStyleInitializationData}
                  context={context}
                  iContent={iContent}
                />
              );
            })}
          </div>
        </div>
      );
    }
    return null;
  }

  function renderAdditionalServices() {
    const couponAddons = abroadAddons?.filter(addon => addon.type === AddonType.Coupon && addon.isPurchased);
    if (subscriberMobile != '' && (couponAddons?.length > 0 || insuranceInfo?.exist)) {
      return (
        <div className='selfcare-abroad-customer-existing-packages-main'>
          <div className='row abroad-package-container'>
            <div className='header'>שירותים נוספים לחו״ל</div>
            {insuranceInfo?.exist && <SelfCareAbroadInsurance context={context} linkForCollaborationInsurance={linkForCollaborationInsurance} />}
            {couponAddons?.length > 0 &&
              couponAddons.map((el, index) => {
                return (
                  <SelfCareAbroadScreenIlAddon
                    key={index}
                    couponData={el}
                  />
                );
              })}
          </div>
        </div>
      );
    }
    return null;
  }

  function renderPackageData() {
    if (customerAbroadPackagesStatus === 'pending' ) {
      return <SelfCareAbroadExistingPackagesSkeleton />;
    }
    if (Array.isArray(packageData)) {
      return (
        <>
          {renderAbroadCustomerExistingPackages()}
          {renderAbroadCustomerDefaultExistingPackages()}
          {renderAdditionalServices()}
        </>
      );
    }
    return null;
  }


  return renderPackageData();
}

const mapStateToProps = (state) => ({
  userUsageData: state.selectedSubscriber?.abroadUsage?.data,
  subUsage: state.cellcomAbroad.subscriberAbroadUsageData,
  packageData: state.selfcarePage.selectedSubscriber?.abroadPackages?.regularPackages ?? [],
  autoPackageData: state.selfcarePage.selectedSubscriber?.abroadPackages?.autoPackages ?? [],
  customerAbroadPackagesStatus : state.selfcarePage.selectedSubscriber?.abroadPackages?.status,
  shadowPackagesNotToShowMessage: state.cellcomAbroad.shadowPackagesNotToShowMessage,
  businessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
  mobile: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
    ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
    : state.cellcomAbroad.otpData.otpPhone,
  phoneNumber: state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
  privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
  businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
  goldBusinessSocPackageFolderId: state.cellcomAbroad.epiStyleInitializationData.goldBusinessSocPackageFolderId,
  portalsBlock: state.portalsBlock,
  socPackageRemoveStatus: state.cellcomAbroad.socPackageRemoveStatus,
  loader: state.loader,
  selfCareData: state.selfcarePage,
  isCancelOrUpdatePackagePending: state.cellcomAbroad.isCancelOrUpdatePackagePending,
  abroadAddons: state.selfcarePage?.selectedSubscriber?.abroadAddons,
  insuranceInfo: state.cellcomAbroad?.abroadPermanentInsuranceSocData,
  subscriberMobile: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
  isFetchAbroadData: state.selfcarePage?.selectedSubscriber?.isFetchAbroadData,
});

const mapDispatchToProps = {
  getUsageData,
  setActiveLobbyTab,
  getCustomerAbroadPackages,
  getCustomerAbroadPackagesBusinessIndividual,
  resetSocPackageRemoveStatus,
  hideAppLoader,
  setAbroadLobbyBlockId,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareAbroadCustomerExistingPackagesMain);
